let currentAuthToken = '';

export function setToken(token: string) {
  currentAuthToken = token;
}

export function getCurrentAccessToken() {
  return currentAuthToken;
}
